import React from "react";
import { Star, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function HeroSection() {
  const navigate = useNavigate();

  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 bg-hero-pattern bg-cover bg-center bg-no-repeat" />
      <div className="absolute inset-0 bg-gradient-to-br from-volt-deep-blue/90 via-volt-deep-blue/80 to-transparent" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 relative">
        <div className="text-center max-w-3xl mx-auto">
          <div className="inline-flex items-center px-4 py-2 bg-volt-blue/10 rounded-full mb-8">
            <Star className="h-4 w-4 text-volt-blue mr-2" />
            <span className="text-sm text-volt-blue font-medium">
              Rated 4.9/5 by WordPress developers
            </span>
          </div>

          <h1 className="text-6xl font-bold tracking-tight text-white mb-6 leading-tight">
            Create Beautiful WordPress{" "}
            <span className="relative">
              <span className="relative z-10 bg-gradient-to-r from-volt-green via-volt-blue to-volt-green text-transparent bg-clip-text">
                Block Patterns
              </span>
              <span className="absolute bottom-0 left-0 w-full h-3 bg-volt-blue/20 -rotate-1"></span>
            </span>
          </h1>

          <p className="text-xl text-gray-300 mb-12 max-w-2xl mx-auto leading-relaxed">
            Transform your ideas into stunning WordPress layouts in seconds.
            Simply describe what you want, and our AI will generate beautiful,
            production-ready block patterns.
          </p>

          <div className="flex items-center justify-center space-x-4">
            <button
              onClick={() => navigate("/generator")}
              className="group px-8 py-4 text-lg text-volt-deep-blue bg-volt-green rounded-lg font-medium transition-all hover:translate-y-[-2px] hover:shadow-lg hover:shadow-volt-green/25 focus:ring-2 focus:ring-volt-green focus:ring-offset-2 focus:ring-offset-volt-deep-blue"
            >
              Start Creating
              <ArrowRight className="inline-block ml-2 h-5 w-5 transition-transform group-hover:translate-x-1" />
            </button>
            <button
              onClick={() => navigate("/templates")}
              className="px-8 py-4 text-lg text-gray-300 bg-white/5 backdrop-blur-sm rounded-lg font-medium hover:bg-white/10 transition-colors"
            >
              View Templates
            </button>
          </div>

          <div className="mt-12 flex justify-center space-x-12 text-center">
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold text-volt-green mb-1">
                10K+
              </div>
              <div className="text-sm text-gray-400">Active Users</div>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold text-volt-blue mb-1">50K+</div>
              <div className="text-sm text-gray-400">Patterns Created</div>
            </div>
            <div className="flex flex-col items-center">
              <div className="text-2xl font-bold text-volt-green mb-1">98%</div>
              <div className="text-sm text-gray-400">Satisfaction Rate</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
